






































































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import baseEntityListComponent from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import ClipboardMixin from '@/Shared/ClipboardMixin';
import { TicketTemplate } from './Types';

export default mixins(ClipboardMixin, LocationBasedMixin, baseEntityListComponent<TicketTemplate>()).extend({
    name: 'TicketTemplates',
    components: {
        TemplateBuilder: () => import('./TemplateBuilder.vue'),
    },
    data() {
        return {
            i18nPrefix: 'admin.ticketTemplate',
        };
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/ticketTemplate`;
        }
    },
    methods: {
        onDeleteError(e: any) {
            if (!e.response || e.response.status !== 409) {
                // continue normally
                return true;
            }

            const translatedTitle =
                this.$i18n.t(`${this.i18nPrefix}.deleteFailedTitle`);
            const translatedMessage =
                this.$i18n.t(`${this.i18nPrefix}.templateInUseMessage`);
            this.$bvToast.toast(translatedMessage.toString(), {
                title: translatedTitle.toString(),
                autoHideDelay: 5000
            });

            return false;
        },
    }
});

